import {Bell, BookOpen, Calendar, ChartBar, FileCheck, TimerIcon} from 'lucide-react';
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";

export default function SummaryCards({teacherDashboard}) {


    const summaryData = [
        {
            link: URLS.teacher.lessons.dashboard + '?filter=all',
            title: 'تاریخجه فعالیت‌های من',
            value: teacherDashboard?.data?.data?.lessons_count ?? 0,
            icon: BookOpen,
            color: 'from-blue-500 to-blue-600',
            change: 'تعداد قرآن آموزان ' + (teacherDashboard?.data?.data?.students_count ?? 0) + ' نفر ',
            suffix: 'کلاس',

        },
        {
            link: URLS.teacher.lessons.dashboard + '?filter=active',
            title: 'کلاس‌های فعال',
            value: teacherDashboard?.data?.data?.lessons_active_count ?? 0,
            icon: Calendar,
            color: 'from-green-500 to-green-600',
            change: 'تعداد قرآن آموزان ' + (teacherDashboard?.data?.data?.students_count_in_active_class ?? 0) + ' نفر ',
            suffix: 'کلاس'
        },
        // {
        //     link: '#',
        //     title: 'تعداد دانش آموزان',
        //     value: teacherDashboard?.data?.data?.students_count ?? 0,
        //     icon: Users,
        //     color: 'from-purple-500 to-purple-600',
        //     change: 'در مجموع همه کلاس‌های شما',
        //     suffix: 'نفر'
        // },
        {
            link: URLS.teacher.homeworks.dashboard,
            title: 'تکالیف در انتظار',
            value: teacherDashboard?.data?.data?.homework_awaiting_count ?? 0,
            icon: FileCheck,
            color: 'from-orange-500 to-orange-600',
            change: 'برای بررسی تکالیف کلیک کنید'
        },

        {
            link: URLS.teacher.reports.dashboard,
            title: 'گزارش‌های ثبت شده',
            value: teacherDashboard?.data?.data?.teacher_report ?? 0,
            icon: ChartBar,
            color: 'from-emerald-500 to-emerald-600',
            change: 'برای مشاهده گزارش‌های ثبت شده کلیک کنید',
            suffix: 'گزارش'
        },
        {
            link: URLS.teacher.times.dashboard,
            title: 'زمان‌های فعالیت من',
            value: teacherDashboard?.data?.data?.total_time_second ? ((teacherDashboard?.data?.data?.total_time_second / 60) / 60) : 0,
            icon: TimerIcon,
            color: 'from-pink-500 to-pink-600',
            change: 'برای مشاهده  زمان‌های فعالیت ثبت شده کلیک کنید',
            suffix: 'ساعت'
        },
        {
            link: URLS.notification.teacher,
            title: 'پیام های خوانده نشده',
            value: teacherDashboard?.data?.data?.notifications_count ?? 0,
            icon: Bell,
            color: 'from-cyan-500 to-cyan-600',
            change: 'برای نمایش پیام‌ها کلیک کنید',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {summaryData.map((item, index) => (
                <Link to={item.link} key={index + 'teacher-dashboard-item'}>
                    <div

                        className=" rounded-xl p-6 shadow-sm border dark:border-gray-600 border-gray-100 hover:shadow-md transition-all duration-200 cursor-pointer group"
                    >
                        <div className="flex items-start justify-between mb-4">
                            <div
                                className={`w-12 h-12 bg-gradient-to-br ${item.color} rounded-lg flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform duration-200`}>
                                <item.icon className="w-6 h-6 text-white"/>
                            </div>
                            <div className="text-right">
                                <p className="text-sm   mb-1">{item.title}</p>
                                <h3 className="text-2xl font-bold  ">
                                    {item.value}
                                    {item.suffix &&
                                        <span className="text-sm   font-normal mr-1">{item.suffix}</span>}
                                </h3>
                            </div>
                        </div>
                        <p className="text-xs   text-right">{item?.change}</p>
                    </div>
                </Link>
            ))}
        </div>
    );
}
